import PropTypes from 'prop-types';
import './Button.css';

export default function Button({
    children,
    type = 'button',
    variant = 'primary',
    size = 'md',
    icon: Icon,
    iconPosition = 'left',
    loading = false,
    disabled = false,
    fullWidth = false,
    onClick,
    className = '',
    ...props
}) {
    const classes = [
        'btn',
        `btn-${variant}`,
        `btn-${size}`,
        fullWidth && 'btn-full',
        loading && 'btn-loading',
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            type={type}
            className={classes}
            disabled={disabled || loading}
            onClick={onClick}
            {...props}
        >
            {loading && (
                <span className="btn-spinner" />
            )}
            {Icon && iconPosition === 'left' && !loading && (
                <Icon size={size === 'sm' ? 14 : size === 'lg' ? 20 : 16} />
            )}
            {children && <span>{children}</span>}
            {Icon && iconPosition === 'right' && !loading && (
                <Icon size={size === 'sm' ? 14 : size === 'lg' ? 20 : 16} />
            )}
        </button>
    );
}

Button.propTypes = {
    children: PropTypes.node,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    variant: PropTypes.oneOf(['primary', 'secondary', 'danger', 'ghost', 'success', 'warning', 'link']),
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    icon: PropTypes.elementType,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string
};
